import * as moment from 'moment';
import { duration } from 'moment';

export class GetCourseReportStation {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            // Lynx Cloud uses Pascal Casing
            // Lynx Drive uses Camel Casing
            if (this.completedAutomatic == null) this.completedAutomatic = json.CompletedAutomatic ?? json.completedAutomatic;
            if (this.completedManual == null) this.completedManual = json.CompletedManual ?? json.completedManual;
            if (this.hasError == null) this.hasError = json.HasError ?? json.hasError;
            if (this.isRunning == null) this.isRunning = json.IsRunning ?? json.isRunning;
            if (this.stationId == null) this.stationId = json.StationId ?? json.stationId;
            if (this.totalDelta == null) this.totalDelta = duration(json.TotalDelta ?? json.totalDelta);

            delete this['CompletedAutomatic'];
            delete this['CompletedManual'];
            delete this['HasError'];
            delete this['IsRunning'];
            delete this['StationId'];
            delete this['TotalDelta'];
        }
    }

    completedAutomatic: string;
    completedManual: string;
    hasError: boolean;
    isRunning: boolean;
    stationId:number;
    totalDelta: moment.Duration;
}
